<script setup lang="ts">
defineOptions({
  name: 'SidebarNavigationHamburger',
})

withDefaults(defineProps<{
  open?: boolean
}>(), {
  open: false,
})
</script>

<template>
  <div class="hamnimate flex flex-col items-center gap-1 p-2 mx-1">
    <div class="bg-white w-5 h-1 rounded-full" />
    <div
      class="bg-white h-1 rounded-full transition-all"
      :class="{ 'w-3.5': open, 'w-5': !open }"
    />
    <div
      class="bg-white h-1 rounded-full transition-all"
      :class="{ 'w-1.5': open, 'w-5': !open }"
    />
  </div>
</template>
